import React from "react";

export default function ActiveRequest(data: any) {
  let contact = data.info.contact;
  contact = `0${contact.substr(2)}`
  return (
      <tr>
        <td>{data.info.name}</td>
        <td>{contact}</td>
        <td>{data.info.city}</td>
        <td>{data.info.email}</td>
        <td>{data.info.bloodGroup}</td>
        <td>{data.info.urgency}</td>
        <td>{data.info.transportation}</td>
        <td>{data.info.type}</td>
        <td>{data.info.hospital}</td>
        <td><button className={`${data.info.isActive ? "btn btn-success" : "btn btn-danger" }`}>{data.info.isActive ? "Active" : "Inactive"}</button></td>
      </tr>
  )
}
